import React from "react";
import Button from "../Components/Button";
import styles from "../statics/styles/settings-mobile-header.scss";
const SettingsMobileHeader = (props) => {
  const { onCancel, saveLabel, cancelLabel, title, t, children, showSaveBtn = true } = props;
  const onSave = props.showSaveBtn ? props.onSave : () => {
  };
  const saveText = saveLabel || t("SettingsPanelFooter_Save");
  const cancelText = cancelLabel || t("SettingsPanelFooter_Cancel");
  const buttonsDataHook = { save: "actionButtonSave", cancel: "actionButtonCancel" };
  const renderButton = (text, dataHook, onClick, showBtn = true) => /* @__PURE__ */ React.createElement(
    Button,
    {
      ariaLabel: text,
      isMobile: true,
      dataHook,
      onClick,
      style: !showBtn ? { visibility: "hidden" } : {}
    },
    text
  );
  return /* @__PURE__ */ React.createElement("div", { className: styles.setting_mobile_header }, renderButton(saveText, buttonsDataHook.save, onSave, showSaveBtn), /* @__PURE__ */ React.createElement(React.Fragment, null, title && /* @__PURE__ */ React.createElement("div", { className: styles.setting_mobile_header_title }, title), children), renderButton(cancelText, buttonsDataHook.cancel, onCancel));
};
var SettingsMobileHeader_default = SettingsMobileHeader;
export {
  SettingsMobileHeader_default as default
};
//# sourceMappingURL=SettingsMobileHeader.js.map
